<template>
    <BreadCrumb :items="breadcrumbItems" />
    <main id="main">
        <NoticeListForm/>
    </main>
</template>
<script>
import NoticeListForm from '@/components/customerService/NoticeListForm.vue';
import BreadCrumb from '../layout/navigation/BreadCrumb.vue';

export default {
    data() {
        return {
            breadcrumbItems: [
                { href: "/", text: "홈", isHome: true },
                { href: "#", text: "고객센터" },
            ],
        };
    },
    components: {
        NoticeListForm,
        BreadCrumb
    }
}
</script>
<style lang="">

</style>